<template>
  <v-container
    class="pa-0"
  >
    <v-container
      class="primary white--text px-4 py-12"
    >
      <h1
        class="display-4"
      >
        Blogi.
      </h1>

      <div
        class="overline font-weight-bold ml-2"
      >
        Parasta lukemista
      </div>
    </v-container>

    <v-container
      class="pa-4"
    >
      <v-progress-circular
        v-if="$wait.is('loading blog posts')"
        indeterminate
      />

      <template
        v-else
      >
        <h2
          class="subtitle-1 mt-1 mb-4 font-weight-bold primary--text"
        >
          Tässä viimeisimpiä
        </h2>

        <v-card
          v-for="(post, i) in blogPosts"
          :key="i"
          :href="post.link"
          target="_blank"
        >
          <v-img
            v-if="post.media"
            :src="post.media.sizes.medium_large.source_url"
            max-height="160px"
            cover
          />

          <div
            style="
          margin-top: -60px;
          padding-top: 32px;
          transform: translateZ(0);
          background: linear-gradient(0deg, rgba(255,255,255,1) 75%, rgba(255,255,255,0) 100%);
        "
          >
            <v-card-title
              style="word-break: break-word;"
            >
              {{ post.title.rendered }}
            </v-card-title>

            <v-card-subtitle
              class="mt-n2"
            >
              <v-icon
                small
                left
              >
                schedule
              </v-icon>
              {{ $dayjs(post.date).format('DD.MM.YYYY') }}
            </v-card-subtitle>
          </div>

          <v-card-text
            v-html="post.excerpt.rendered.replace(/<a\b[^>]*>(.*?)<\/a>/i,'').replace('&nbsp;', '')"
            class="post-excerpt pt-2"
          />

          <v-card-actions
            class="px-4 pb-4 justify-center"
          >
            <v-btn
              outlined
              color="primary"
            >
              Jatka lukemista

              <v-icon
                small
                right
              >
                keyboard_arrow_right
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-container>
  </v-container>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      blogPosts: 'blog/blogPosts',
    }),
  },

  created() {
    this.loadBlogPosts();
  },

  methods: {
    ...mapWaitingActions('blog', {
      loadBlogPosts: 'loading blog posts',
    }),
  },
};
</script>

<style lang="scss">
  .post-excerpt p {
    margin-bottom: 0;
  }
</style>
